import * as React from 'react'
import { Highlight } from 'react-instantsearch-dom'
import classNames from 'classnames'
import { DictionaryValue } from '../../components/dictionary-value'
import { star, Icon, starFilled } from '../../components/icon'
import { DealType } from '../../models/dealType'
import { SearchHit } from '../search/types'
import { getDealUrl } from '../interstitial'
import CardPresentation from './CardPresentation'
import EventType from '../../models/eventType'

type Props = {
    id: string
    title: string
    slug: string
    offer: string
    imageUrl: string
    brandName?: string
    brandUrl?: string
    brandImageUrl?: string
    optional1?: string
    optional2?: string
    type?: DealType
    eventType?: EventType
    location?: 'home' | 'default'
    showHover?: boolean
    hit?: SearchHit
    className?: string
    isFavourite?: boolean
    favDealId?: string
    toggleFavourite?: (e: React.MouseEvent) => void
}

class Card extends React.Component<Props> {
    static defaultProps = {
        type: 'gold',
    }

    highlightAttribute(attribute: string, fallback: string) {
        const { hit } = this.props

        if (hit !== undefined) {
            return <Highlight attribute={attribute} hit={hit} tagName='mark' />
        }

        return fallback
    }

    render() {
        const {
            title,
            slug,
            offer,
            optional1,
            optional2,
            isFavourite,
        } = this.props

        const cta = <DictionaryValue token='go-to-deal' />
        const icon = (
            <Icon
                classPrefix='deal-card__'
                classModifier={isFavourite ? 'filled' : 'outlined'}
                className='deal-card__favourite-wrapper'
                wrappingElement='div'
                icon={isFavourite ? starFilled : star}
                onClick={this.props.toggleFavourite}
            />
        )
        const url = getDealUrl(slug)

        return (
            <CardPresentation
                {...this.props}
                cta={cta}
                url={url}
                offer={this.highlightAttribute('offer', offer)}
                formattedTitle={this.highlightAttribute('title', title)}
                formattedOptional1={optional1 ? this.highlightAttribute('details', optional1) : undefined}
                formattedOptional2={optional2 ? this.highlightAttribute('redemptionInfo', optional2) : undefined}
                icon={icon}
            />
        )
    }
}

export default Card
